// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  defId: __t.string().primaryKey().name("def_id"),
  category: __t.string(),
  styleX100: __t.i32().name("style_x100"),
  comfortX100: __t.i32().name("comfort_x100"),
  attractionX100: __t.i32().name("attraction_x100"),
  ratingBonusX100: __t.i32().name("rating_bonus_x100"),
  surface: __t.string(),
});
